import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import {
  Paper,
  Table,
  TableBody,
  TableHead,
  TableRow,
} from '@mui/material';

import { DateFormat } from '../../../../../../utils/date';
import { formatCurrencyCents } from '../../../../../../utils/formatters';
import CopyButton from '../../../../../../components/CopyButton';

import {
  StyledTableContainer,
  StyledTableCell,
  StyledLink,
} from './styles';
import { getInvoiceStatusLabel } from './invoiceStatus';
import texts from './texts.json';

const InvoiceTable = ({ invoiceList, renderAction, productLabelFor }) => (
  <StyledTableContainer component={Paper}>
    <Table stickyHeader>
      <TableHead>
        <TableRow>
          <StyledTableCell>{texts.invoiceNo}</StyledTableCell>
          {!!productLabelFor && <StyledTableCell>{texts.product}</StyledTableCell>}
          <StyledTableCell>{texts.amount}</StyledTableCell>
          <StyledTableCell>{texts.dateCreated}</StyledTableCell>
          <StyledTableCell>{texts.paymentDate}</StyledTableCell>
          <StyledTableCell>{texts.statusHeader}</StyledTableCell>
          {renderAction && <StyledTableCell>{texts.action}</StyledTableCell>}
        </TableRow>
      </TableHead>
      <TableBody>
        {invoiceList.map((invoice) => (
          <TableRow key={invoice.id}>
            <StyledTableCell>
              <StyledLink href={invoice.hosted_invoice_url} target="_blank">
                {invoice.number}
              </StyledLink>
              <CopyButton value={invoice.hosted_invoice_url} />
            </StyledTableCell>
            {!!productLabelFor && (
              <StyledTableCell>
                {productLabelFor(invoice)}
              </StyledTableCell>
            )}
            <StyledTableCell>
              {formatCurrencyCents(invoice.total, invoice.currency)}
            </StyledTableCell>
            <StyledTableCell>
              {moment.unix(invoice.created).format(DateFormat.MONTH_NAME_DATE_FORMAT)}
            </StyledTableCell>
            <StyledTableCell>
              {invoice.status_transitions?.paid_at
                ? moment.unix(invoice.status_transitions.paid_at).format(DateFormat.MONTH_NAME_DATE_FORMAT)
                : texts.emptyText}
            </StyledTableCell>
            <StyledTableCell>
              {getInvoiceStatusLabel(invoice)}
            </StyledTableCell>
            {renderAction && (
              <StyledTableCell>
                {renderAction(invoice)}
              </StyledTableCell>
            )}
          </TableRow>
        ))}
      </TableBody>
    </Table>
  </StyledTableContainer>
);

InvoiceTable.propTypes = {
  invoiceList: PropTypes.arrayOf(PropTypes.object).isRequired,
  renderAction: PropTypes.func,
  productLabelFor: PropTypes.func,
};

InvoiceTable.defaultProps = {
  renderAction: null,
  productLabelFor: null,
};

export default InvoiceTable;
